import React from 'react';

import { SPACE_OVERVIEW } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { useIsSSROrHydrating } from '@confluence/ssr-utilities/entry-points/useIsSSROrHydrating.ts';
import { SpaceOverviewSwitcherLoader } from '@confluence/space-overview/entry-points/SpaceOverview.ts';

const SpaceIndexOverview = ({
	spaceKey,
	query,
}: {
	spaceKey: string;
	query: RouteMatch['query'];
}) => {
	const isSSROrHydrating = useIsSSROrHydrating();

	if (expValEquals('confluence_react_streaming_all_routes', 'isEnabled', true)) {
		return (
			<>
				<SpaceOverviewSwitcherLoader spaceKey={spaceKey} />
				{/* Keep the SSR overview mounted while the router canonicalizes the URL. */}
				{!isSSROrHydrating && (
					<Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey, query }} />
				)}
			</>
		);
	}

	return <Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey, query }} />;
};

/**
 * Keeping the redirection because refined themes only support space overview route.
 * https://atlassian.slack.com/archives/CFGSEJDFT/p1721136254384829
 */
export const SpaceIndexRoute: {
	(match: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey }, query: { mode } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					isGlobalMode: boolean;
					navdexPointType: string;
					spaceKey: string;
				};
			};
			pageState: {
				spaceKey: string;
				contentId: any;
				routeName: string;
				contentType: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = getSpaceOverviewRoute(SpaceIndexOverview);
